module.exports = __webpack_public_path__ + "files/e087d0fbb33a371bac9958af91642bf1.png";